var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarousel24 = function SvgCarousel24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5A1.5 1.5 0 0 0 7.5 5h9a1.5 1.5 0 0 0 0-3h-9A1.5 1.5 0 0 0 6 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 17A5 5 0 0 1 8 7h8a5 5 0 0 1 0 10H8Zm-3-5a3 3 0 0 0 3 3h8a3 3 0 1 0 0-6H8a3 3 0 0 0-3 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20.5A1.5 1.5 0 0 0 7.5 22h9a1.5 1.5 0 0 0 0-3h-9A1.5 1.5 0 0 0 6 20.5Z",
    fill: "currentColor"
  })));
};
export default SvgCarousel24;